import Loader from "@/atoms-react/loader/Loader.react";
import { usePartnerInfo } from "@/features/partner/hooks/use-partner-information";
import { useUser } from "@/features/user/hooks/use-user";
import { identityPartners } from "@/features/user/types";
import { useMemo, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export const ConsentRoutes = () => {
  const { partnerUuidQuery } = usePartnerInfo();
  const { data: dataPartner, isLoading: isLoadingDataPartner } = partnerUuidQuery(
    (sessionStorage.getItem("origin") as string) ?? null
  );
  const { useUserProfile } = useUser();
  const { data: user, isPending } = useUserProfile();
  const [loading, setLoading] = useState<boolean>(false);
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const isConsentEnabled = useMemo(() => {
    setLoading(true);
    if (user?.identityPartners && dataPartner) {
      const found = user?.identityPartners?.find(
        (partner: identityPartners) => partner.uuid === dataPartner?.data.partner_uuid
      );
      const minLvl = found?.minimum_olkypass_level ?? 2;
      const isLevel2 = user ? user.olkyPassLevel.olkypass_status.level >= minLvl : false;
      if (found && isLevel2) {
        setLoading(false);
        return true;
      }
    }
    setLoading(false);
    return false;
  }, [user, dataPartner]);
  if (loading || isLoadingDataPartner || isPending)
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Loader />
      </div>
    );

  return isConsentEnabled ? <Outlet /> : <Navigate to={from} />;
};
